import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import common from 'src/styles/common.module.scss'
import styles from '../styles.module.scss'

export const TextHeaderIt = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    return (
        <HighlightedText
            text="RICHIEDI IL TUO BONUS"
            highlights={[
                { word: 'RICHIEDI' },
                { word: 'IL' },
                { word: 'TUO' },
                { word: 'BONUS' },
            ]}
            breakAfterWords={isDesktop ? [] : ['TUO']}
            className={common.text_header}
        />
    )
}

export const TextLandIt = () => {
    return (
        <HighlightedText
            text="bonus del 325% + 400 GIRI GRATUITI"
            highlights={[{ word: '325%' }, { word: '+ 400' }]}
            breakAfterWords={['325%']}
            className={styles.text_content}
        />
    )
}
